module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("Qve3Y"))).then(() => parcelRequire('hEqeo'));